import { Base } from '@studiometa/js-toolkit';

/**
 * ProductRecommendations
 */
export default class ProductRecommendations extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ProductRecommendations',
    options: {
      url: {
        type: String,
        default: '',
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$options.url === '') {
      return;
    }

    fetch(this.$options.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('[data-component="ProductRecommendations"]');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.$el.innerHTML = recommendations.innerHTML;
        }
        this.$parent.$update();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
